import { gradeFromGradYear } from "@/utils/gradeFromGradYear";
import type { AdminAbsentStudent } from "@/types/tables";

export const buildAbsentStudentRows = (data: any): AdminAbsentStudent[] => {
  const rows: AdminAbsentStudent[] = [];

  for (const r of data) {
    rows.push({
      _id: r._id,
      name: r.name,
      email: r.email,
      gradeLevel: gradeFromGradYear(r.gradYear),
      explorationName: r.exploration.name,
    });
  }

  return rows;
};
